import React from 'react';
import { 
  FaUsers, 
  FaClock, 
  FaEuroSign, 
  FaShieldAlt, 
  FaAward,
  FaHeadset,
  FaTruck,
  FaBox,
  FaGift
} from 'react-icons/fa';
import './WhyUs.css';

const WhyUs = () => {
  const features = [
    {
      icon: <FaUsers />,
      title: "Équipe professionnelle",
      description: "Personnel qualifié et expérimenté pour un service de qualité",
      stats: "10+ ans d'expérience"
    },
    {
      icon: <FaClock />,
      title: "Service rapide",
      description: "Intervention rapide dans les plus brefs délais",
      stats: "24/7 disponible"
    },
    {
      icon: <FaEuroSign />,
      title: "Prix compétitifs",
      description: "Devis gratuit et tarifs transparents sans surprise",
      stats: "Sans frais cachés"
    },
    {
      icon: <FaShieldAlt />,
      title: "Sécurité des biens",
      description: "Assurance tous risques pour vos biens précieux",
      stats: "100% couvert"
    },
    {
      icon: <FaAward />,
      title: "Certification qualité",
      description: "Label qualité et certifications professionnelles",
      stats: "ISO 9001"
    },
    {
      icon: <FaHeadset />,
      title: "Support client",
      description: "Assistance téléphonique et suivi personnalisé",
      stats: "Réponse 24h"
    },
    {
      icon: <FaGift />,
      title: "Scotch et carton offerts",
      description: "Matériel d'emballage de qualité fourni gratuitement pour votre déménagement",
      stats: "100% offert"
    }
  ];

  return (
    <section className="why-us" id="why-us">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">POURQUOI NOUS CHOISIR</span>
          <h2 className="section-title">
            Des <span className="highlight">professionnels</span> à votre service
          </h2>
          <p className="section-description">
            Découvrez les raisons qui font de nous le partenaire idéal pour vos déménagements.
          </p>
        </div>

        {/* Grille des fonctionnalités */}
        <div className="whyus-grid">
          {features.map((feature, index) => (
            <div key={index} className="whyus-card">
              <div className="whyus-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              <div className="whyus-stats">
                {feature.stats}
              </div>
            </div>
          ))}
        </div>

        {/* Statistiques globales */}
        <div className="whyus-stats-global">
          <div className="stat-item">
            <div className="stat-number">5000+</div>
            <div className="stat-label">DÉMÉNAGEMENTS RÉALISÉS</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">98%</div>
            <div className="stat-label">CLIENTS SATISFAITS</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">15</div>
            <div className="stat-label">ANNÉES D'EXPÉRIENCE</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;